import axios from 'axios'
const baseUri = "WebApi.asmx/api/dataGrid";
const store = {};
const mutations = {};
const state = {};
const getters = {
    getGridState(controlName, viewName) {
        return axios.get(baseUri + '/GetState', { params: { ControlName: controlName, ViewName: viewName } });
    }
};
const actions = {
    saveGridState(controlName, viewName, state) {
        axios.get(baseUri + '/GetState', { params: { ControlName: controlName, ViewName: viewName, State: state } });
    }
};

export default {
    state,
    store,
    mutations,
    getters,
    actions
}